export enum FEATURE_FLAG {
  TAG_FEATURE = 'tag_feature',
  LEA_FEATURE = 'lea_feature',
  HUBS_FEATURE = 'hubs_feature',
  CUSTOMERS_FEATURE = 'customers',
  CARGAS_FEATURE = 'cargas_feature',
  PRICING_FEATURE = 'pricing_feature',
  REPORTS_FEATURE = 'reports_feature',
  PANDA_BOX_FEATURE = 'panda_box_feature',
  VS_EXPORT_FEATURE = 'vs_export_feature',
  ROUTING_FEATURE = 'simple_shift_feature',
  PDI_EXPORT_FEATURE = 'pdi_export_feature',
  ENABLE_METER_FEATURE = 'lcr_meter_feature',
  DM2_EXPORT_FEATURE = 'dm2_export_feature',
  GL_MAPPING_FEATURE = 'gl_mapping_feature',
  HOUR_FRAME_FEATURE = 'hour_frame_feature',
  HIDE_ERP_ID_FEATURE = 'hide_erp_id_feature',
  BOL_PRICING_FEATURE = 'bol_pricing_feature',
  TANK_MONITORING = 'tank_monitoring_feature',
  HANDLE_TENANT_ROLES = 'handle_tenant_roles',
  DRIVER_RATE_FEATURE = 'driver_rate_feature',
  SPLASH_BLEND_FEATURE = 'splash_blend_feature',
  PRICING_TYPE_SETTING = 'pricing_type_setting',
  RENTAL_ASSET_FEATURE = 'rental_asset_feature',
  TOWER_EXPORT_FEATURE = 'towerx_export_feature',
  LUBE_DELIVERY_FEATURE = 'lube_delivery_feature',
  SHIFT_BUILDER_FEATURE = 'shift_builder_feature',
  COMPANY_ADDRESS_LATITUDE = 'company_address_lat',
  CARDLOCK_FEATURE = 'card_lock_transaction_feature',
  COMMON_CARRIER_FEATURE = 'common_carrier_feature',
  ENABLE_ROUTING_FEATURE = 'enable_routing_feature',
  VENDOR_PRICING_FEATURE = 'vendor_pricing_feature',
  TRANSFER_ORDER_FEATURE = 'transfer_order_feature',
  COMPANY_ADDRESS_LONGITUDE = 'company_address_lng',
  PERTROL_EXPORT_FEATURE = 'petrolrx_export_feature',
  CUSTOMER_IMPORT_FEATURE = 'customer_import_feature',
  BULK_SHIFT_MOVE_FEATURE = 'bulk_shift_move_feature',
  RECURRING_ORDER_FEATURE = 'recurring_order_feature',
  ORDER_LEVEL_TAX_FEATURE = 'order_level_tax_feature',
  CREDIT_APPROVAL_FEATURE = 'credit_approval_feature',
  RESOURCE_TENANT_FEATURE = 'resource_tenant_feature',
  SHOW_ROI_REPORT_FEATURE = 'show_roi_report_feature',
  EXTRACTION_ORDER_FEATURE = 'extraction_order_feature',
  BOOKWORKS_INTEGRATION_FEATURE = 'bookworks_integration_feature',
  LOADING_ORDER_FEATURE = 'loading_order_feature',
  DELIVERY_ORDER_FEATURE = 'delivery_order_feature',
  MINIMUM_TYPE_FEE_FEATURE = 'minimum_type_fee_feature',
  CREDIT_CARD_TYPE_FEATURE = 'credit_card_type_feature',
  DIVERSION_NUMBERS_FEATURE = 'diversion_numbers_feature',
  QUICKBOOKS_ONLINE_FEATURE = 'quickbooks_online_feature',
  SHOW_ASSET_REPORT_FEATURE = 'show_asset_report_feature',
  IRELY_INTEGRATION_FEATURE = 'irely_integration_feature',
  COMPARABLE_PRODUCT_FEATURE = 'comparable_product_feature',
  RECALCULATE_PRICING_FEATURE = 'recalculate_pricing_feature',
  ALLOW_DUPLICATE_FEE_FEATURE = 'allow_duplicate_fee_feature',
  SHOW_GENERATED_NOTES_FEATURE = 'show_generated_notes_feature',
  TAX_CALCULATION_TYPE_FEATURE = 'tax_calculation_type_feature',
  AM_PM_ORDER_GROUPING_FEATURE = 'am_pm_order_grouping_feature',
  QUICKBOOK_CREDIT_CHECK_FEATURE = 'quickbook_credit_check_feature',
  IMPORT_CUSTOMER_ASSETS_FEATURE = 'import_customer_assets_feature',
  CREDIT_CONTROL_MANAGER_FEATURE = 'credit_control_manager_feature',
  ENABLE_CREDIT_LEDGER_FEATURE = 'enable_credit_ledger_feature',
  DELIVERY_ONLY_CUSTOMER_FEATURE = 'delivery_only_customer_feature',
  PRODUCT_PURCHASE_LIMIT_FEATURE = 'product_purchase_limit_feature',
  SALES_REP_FOR_CC_EMAIL_FEATURE = 'sales_rep_for_cc_email_feature',
  DISPLAY_PRODUCT_SOLD_AS_FEATURE = 'display_product_sold_as_feature',
  IMPORT_RECURRING_ORDERS_FEATURE = 'import_recurring_orders_feature',
  ENABLE_NETSUITE_INTEGRATION_FEATURE = 'enable_netsuite_integration_feature',
  PRODUCT_NAME_WITH_ERP_ID_FEATURE = 'product_name_with_erp_id_feature',
  INHERIT_CUSTOMER_PRICING_FEATURE = 'inherit_customer_pricing_feature',
  ASSET_INVENTORY_TRACKING_FEATURE = 'asset_inventory_tracking_feature',
  MERGE_CUSTOMER_RESOURCES_FEATURE = 'merge_customer_resources_feature',
  EXCLUDE_MARGIN_IN_PRICING_FEATURE = 'exclude_margin_in_pricing_feature',
  ENABLE_2FA_AUTHENTICATION_FEATURE = 'enable_2fa_authentication_feature',
  EFFECTIVE_DATETIME_ON_TAX_FEATURE = 'effective_datetime_on_tax_feature',
  SEPARATE_PRODUCT_CODE_ERP_ID = 'separate_product_code_and_erp_id_feature',
  ENABLE_QUICKBASE_INTEGRATION_FEATURE = 'enable_quickbase_integration_feature',
  MASTER_APPLY_APPLICABLE_TAX_FEATURE = 'master_apply_applicable_tax_feature',
  SEND_CUSTOMER_PRICING_QUOTE_FEATURE = 'send_customer_pricing_quote_feature',
  COMPARABLE_LOADING_PRODUCTS_FEATURE = 'comparable_loading_products_feature',
  TANK_MONITORING_SHOW_PRODUCT_FEATURE = 'tank_monitoring_show_product_feature',
  SHOW_PERCENTAGE_BASED_ULLAGE_FEATURE = 'show_percentage_based_ullage_feature',
  BULK_PLANT_SHIFT_AUTO_CREATE_FEATURE = 'bulk_plant_shift_auto_create_feature',
  SHOW_SHIPTO_IN_CUSTOMER_EDIT_FEATURE = 'show_shipto_in_customer_edit_feature',
  SHOW_INVOICE_STATUS_ON_ORDERS_FEATURE = 'show_invoice_status_on_orders_feature',
  NOTIFY_ORDER_CREATE_TO_DRIVER_FEATURE = 'notify_order_create_to_driver_feature',
  AUTO_POPULATE_ORDER_FEATURE = 'populate_load_order_from_previous_shift_feature',
  ORDER_GROUP_READY_TO_SYNC_FEATURE = 'order_groups_ready_to_sync_status_feature',
  ENABLE_MANUAL_DELETION_OF_TAX_FEATURE = 'enable_manual_deletion_of_tax_feature',
  BULK_DOWNLOAD_DELIVERY_RECEIPT_FEATURE = 'bulk_download_delivery_receipt_feature',
  SHOW_PRODUCT_CATEGORY_AS_LABEL_FEATURE = 'show_product_category_as_label_feature',
  TANK_MONITORING_SHOW_SAFE_ULLAGE_FEATURE = 'tank_monitoring_show_safe_ullage_feature',
  ENABLE_EXTERNAL_ID_IN_BOL_REPORT_FEATURE = 'enable_external_id_in_bol_report_feature',
  LOADING_ACCOUNT_INSTEAD_SUPPLIER_FEATURE = 'loading_account_instead_supplier_feature',
  ONLY_ASSIGNED_TRAILER_TO_TRACTOR_FEATURE = 'only_assigned_trailer_to_tractor_feature',
  ABILITY_TO_MARK_ORDER_AS_ARCHIVED_FEATURE = 'ability_to_mark_order_as_archived_feature',
  ADD_TRANSFERS_STATE_IN_BOL_REPORT_FEATURE = 'add_transfers_state_in_bol_report_feature',
  SYNC_PURCHASE_ORDERS_TO_QUICKBOOKS_FEATURE = 'sync_purchase_orders_to_quickbooks_feature',
  SYNC_PRODUCT_DATA_FROM_QBO_FEATURE = 'qbo_sync_product_data_feature',
  ENABLE_INVOICE_IN_EXTRACTION_ORDER_FEATURE = 'enable_invoice_in_extraction_order_feature',
  Enforce_Single_Default_Delivery_Fee_Feature = 'enforce_single_default_delivery_fee_feature',
  SHIPTO_PREFERRED_TERMINAL_SUPPLIERS_FEATURE = 'shipto_preferred_terminal_suppliers_feature',
  SHOW_ADDITIONAL_COLUMN_IN_DELIVERY_ORDER = 'show_additional_column_in_delivery_order_feature',
  ENABLE_WIDE_DATE_RANGE_FOR_GRAPH_DATA_FEATURE = 'enable_wide_date_range_for_graph_data_feature',
  TANK_MONITORING_SHOW_HEIGHT_AND_VOLUME_FEATURE = 'tank_monitoring_show_height_and_volume_feature',
  ENABLE_COMPARABLE_PRODUCT_BY_DISPATCHER_FEATURE = 'enable_comparable_product_by_dispatcher_feature',
  ENFORCE_ERP_ID_ON_TAGS_FEATURE = 'enforce_erp_id_on_tags_feature',
  EMBEDDED_METABASE_FEATURE = 'embedded_metabase_feature',
  PICK_AND_PACK_FEATURE = 'pick_and_pack_feature',
  // this is a temporary flag, remove every instance later
  // ask tilak for more info
  NEW_ORDER_V3_FEATURE = 'new_order_v3_feature',
  INVOICE_NUMBER_FEATURE = 'invoice_feature',
  USE_PANDABOX_V2_FEATURE = 'use_panda_box_v2_feature',
  SHOW_GENERATOR_RUNNING_HOURS = 'show_generator_running_hours_feature',
  SHOW_BOTH_CUSTOMER_NAME_AND_SHIPTO_NAME_IN_SHIFT_PLANNER_FEATURE = 'show_both_customer_name_and_ship_to_name_in_planner_feature',
  SHIP_TO_FEE_FEATURE = 'shipto_fee_feature',
  EMAIL_DELIVERY_RECEIPT_FEATURE = 'email_delivery_receipt',
  DELIVERY_NOTES_AT_ASSET_FEATURE = 'delivery_notes_at_asset_feature',
  SHOW_CUSTOMER_DETAILS_IN_WEEKLY_SHIFT_PLANNER_FEATURE = 'show_customer_details_in_weekly_shift_planner_feature',
  DEGREE_DAY_FEATURE = 'degree_day_feature',
  USE_LOCAL_TIMEZONE_FEATURE = 'use_local_timezone_feature',
  DIVERGENCE_ORDER_FEATURE = 'divergence_order_feature',
  CUSTOMER_PORTAL = 'customer_portal_feature',
  RFID_FEATURE = 'rfid_feature',
  USAGE_METRICS_FEATURE = 'usage_metrics_feature',
}

export enum USER_FEATURE_FLAG {
  DRIVERS = 'drivers',
  CUSTOMERS = 'customers',
  ALLOW_EDIT_HUB = 'allow_edit_hub',
  ALLOW_CREATE_HUB = 'allow_create_hub',
  ALLOW_USER_MANAGE_LEA = 'allow_user_manage_lea',
  CREDIT_CONTROL_MANAGER = 'credit_control_manager',
  ALLOW_USER_TO_MARK_ORDER_AS_ARCHIVED = 'allow_user_to_mark_order_as_archived',
  ALLOW_USER_TO_CREATE_OR_EDIT_LEA_QUESTIONNAIRE = 'allow_user_create_edit_lea_questionnaire',
}
